var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"page-wrapper pt-0",attrs:{"fluid":""}},[_c('main-menu',{attrs:{"isOpened":true,"options":_vm.options}}),_c('fetch-market-grade')],1)}
var staticRenderFns = []

export { render, staticRenderFns }